export default __webpack_public_path__ + "static/media/logo.aebb861f.PNG";